import Axios from '../../../config/axiosv2';
// import handler from '../../../redux/actions/handler.js';

// const defaultCallback = () => null;
export const getCitasPaciente = (id) => Axios.get(`/citas/paciente/${id}`)

export const getDeudaNota = (id) => Axios.get(`/deudas/paciente/${id}`)
export const setDeudaNota = (id, text) => Axios.post(`/deudas/paciente/${id}`, { value: text })